import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
  CFText,
} from 'components'
import { viewMenu, mobileMenu } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getPdfMenuUrl}>
      {pdfMenuUrl => (
        <CFView>
          <MobileScreen>
            <a
              href={pdfMenuUrl}
              target="_blank"
              style={{ textDecoration: 'none' }}
            >
              <CFView column center w="100%">
                <CFText style={{ fontSize: 15 }} color="#111111" helvitica>
                  menu
                </CFText>
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={pdfMenuUrl}
              target="_blank"
              style={{ textDecoration: 'none' }}
            >
              <CFView column center w="100%">
                <CFText style={{ fontSize: 15 }} color="#111111" helvitica>
                  menu
                </CFText>
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
